import React from 'react';

interface ClientLogo {
  id: string;
  name: string;
  logoUrl: string;
  altText: string;
}

interface AWSAward {
  id: string;
  title: string;
  badgeUrl: string;
  altText: string;
  year?: string;
}

interface SocialProofSectionProps {
  clientLogos: ClientLogo[];
  awsAwards: AWSAward[];
}

const SocialProofSection: React.FC<SocialProofSectionProps> = ({
  clientLogos,
  awsAwards
}) => {
  // Duplicate logos twice for seamless infinite scroll
  const allLogos = [...clientLogos, ...clientLogos];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Client Logos Section */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-lg text-gray-600">
            Join the companies that have transformed their business with HCLTech and AWS
          </p>
        </div>
        
        {/* Scrolling Logos Container */}
        <div className="relative overflow-hidden mb-16">
          <div 
            className="flex animate-scroll-logos"
            style={{ width: `${allLogos.length * 180}px` }}
          >
            {allLogos.map((logo, index) => (
              <div 
                key={`${logo.id}-${index}`}
                className="flex-shrink-0 flex items-center justify-center px-4"
                style={{ width: '180px' }}
              >
                <img
                  src={logo.logoUrl}
                  alt={logo.altText}
                  className="max-h-20 w-auto object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        {/* AWS Awards and Recognition Section */}
        <div className="text-center mb-8 sm:mb-12">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
            AWS Partner Recognition & Awards
          </h3>
          <p className="text-gray-600 mb-8 sm:mb-12">
            Recognized for excellence in AWS partnership and innovation
          </p>
          
          {/* Cloud Competency Diagram */}
          <div className="flex justify-center">
            <img
              src="/images/awards/competencies-cloud.png"
              alt="AWS Competencies Cloud Diagram"
              className="max-w-full h-auto"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;